import { render, staticRenderFns } from "./admissionCue.vue?vue&type=template&id=28cb2e90"
import script from "./admissionCue.vue?vue&type=script&lang=js"
export * from "./admissionCue.vue?vue&type=script&lang=js"
import style0 from "./admissionCue.vue?vue&type=style&index=0&id=28cb2e90&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports